import type { TagResponse } from '../payloads';

export interface TagTO {
  id: string;
  tagName: string;
  shortName: string;
}

export const toTagTO = (tag: TagResponse): TagTO => ({
  id: tag.id.toString(),
  tagName: tag.tag_name,
  shortName: tag.short_name,
});
